
import { useState, useEffect } from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Grid,
} from '@mui/material';
import { account } from '../../services/appwrite';
import UserProfile from './UserProfile';
import UserStats from './UserStats';

export default function Dashboard() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const getUser = async () => {
      try {
        const userData = await account.get();
        setUser(userData);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
    getUser();
  }, []);

  if (!user) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
        <Grid container spacing={2} xs={12} md={4}>
          <UserProfile user={user} />
        </Grid>
        <Grid container spacing={2} xs={12} md={8}>
          <UserStats />
        </Grid>
      </Grid>
    </Container>
  );
}
